import { writable } from 'svelte/store';

export const onlyLocalRequests = writable(JSON.parse(sessionStorage.getItem('onlyLocalRequests')) || 0);

onlyLocalRequests.subscribe((val) => sessionStorage.setItem('onlyLocalRequests', JSON.stringify(val)));
